__turbopack_context__.v({
  "container": "LicenseFinder-module-scss-module__GNSSpW__container",
  "contentCard": "LicenseFinder-module-scss-module__GNSSpW__contentCard",
  "contentTitle": "LicenseFinder-module-scss-module__GNSSpW__contentTitle",
  "groupContent": "LicenseFinder-module-scss-module__GNSSpW__groupContent",
  "root": "LicenseFinder-module-scss-module__GNSSpW__root",
  "tabNav": "LicenseFinder-module-scss-module__GNSSpW__tabNav",
  "tabPanel": "LicenseFinder-module-scss-module__GNSSpW__tabPanel",
});
